module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/email-settings-section/modals/email-alert-modal/email-alert-modal.component.scss
// module id = ./web/modern/components/settings/email-settings-section/modals/email-alert-modal/email-alert-modal.component.scss
// module chunks = 0